import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const geocodeApi = createApi({
  reducerPath: "geocodeApi", // path to the reducer
  baseQuery: fetchBaseQuery({
    baseUrl: "https://maps.googleapis.com/maps/api/geocode",
  }), // base query to fetch data
  endpoints: (builder) => ({
    getGeoLocation: builder.query({
      query: ({ place_id }) =>
        `json?place_id=${place_id}&key=${process.env.REACT_APP_MAPS}`,
    }),
  }),
});

export const { useLazyGetGeoLocationQuery } = geocodeApi;
